/**
 * @file src/helpers/cortexApiKeyHeaders.ts
 * @exports cortexApiKeyHeaders
 * @summary Builds Cortex REST/GraphQL API key headers (`apikey`). The shared `http` client merges this automatically via `registerVidHttpApiKeyResolver`; keep this for call sites that don’t use the shared http instance (or for any place you need to construct headers manually).

/**
 * Returns headers to authenticate Cortex requests with a user or limited API key.
 * Omits the header when `apiKey` is missing so requests can rely on cookies alone.
 */
export function cortexApiKeyHeaders(apiKey: string | null | undefined): Record<string, string> {
	if (!apiKey) {
		return {};
	}
	return { apikey: apiKey };
}
